import { HTMLAttributes, forwardRef } from 'react';

import { cn } from '../utils/cn';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info';
  size?: 'sm' | 'md';
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant = 'default', size = 'md', children, ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center font-semibold rounded-full',
          {
            // Variants (Aurora DS pill/badge tints)
            'border border-[color:var(--ids-border,rgba(255,255,255,0.08))] bg-[color:var(--ids-bg-subtle,#0F1626)] text-[color:var(--ids-text-muted,#94A3B8)]':
              variant === 'default',
            'bg-[color:rgba(var(--ids-success-rgb,34,197,94),0.14)] text-[color:var(--ids-success,#22C55E)]':
              variant === 'success',
            'bg-[color:rgba(var(--ids-warning-rgb,245,158,11),0.16)] text-[color:var(--ids-warning,#F59E0B)]':
              variant === 'warning',
            'bg-[color:rgba(var(--ids-danger-rgb,239,68,68),0.14)] text-[color:var(--ids-danger,#EF4444)]':
              variant === 'error',
            'bg-[color:rgba(var(--ids-info-rgb,59,130,246),0.14)] text-[color:var(--ids-info,#3B82F6)]':
              variant === 'info',
            // Sizes
            'px-2 py-0.5 text-xs': size === 'sm',
            'px-2.5 py-1 text-sm': size === 'md',
          },
          className
        )}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Badge.displayName = 'Badge';
